import Axios from "axios";
import {
    SET_ASSET_CATEGORY_LIST,
    UNSET_ASSET_CATEGORY_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetCategory, getAssetCategoryList } from "@/store/api";

const state = {
    getAssetCategoryList: [],
};

const getters = {
    getAssetCategoryList(state) {
        return state.getAssetCategoryList;
    }
};

const mutations = {
    [SET_ASSET_CATEGORY_LIST](state, data) {
        state.getAssetCategoryList = data;
    },
    [UNSET_ASSET_CATEGORY_LIST](state) {
        state.getAssetCategoryList = [];
    }
};

const actions = {
    saveUpdateAssetCategory({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetCategory, data)
                .then(function (response) {
                resolve(response);
                })
                .catch(function (error) {

                reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetCategoryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetCategoryList, data)
                .then(function (response) {
                commit('SET_ASSET_CATEGORY_LIST', response.data.data)
                resolve(response);
                })
                .catch(function (error) {
                commit('UNSET_ASSET_CATEGORY_LIST')
                reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
